import './App.css';
import Banner from './Components/Banner';
import EventCard from './Components/EventCard';
import Form from './Components/Form';
import Names from './Components/Names';
import Footer from './Components/Footer';
function App() {
  return (
      <>
      <Banner/>
      <EventCard/>
      <Form/>
      <Names/>
      <Footer/>
      </>
  );
}

export default App;
